import React from 'react';
import PropTypes from 'prop-types';

const CreatePartnership = ({ color, width, height, ariaLabel }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <g stroke="#302D44" strokeLinecap="round" strokeLinejoin="round">
        <path
          d="M13.852-.5c1.295 0 2.465.523 3.312 1.37.847.847 1.37 2.017 1.37 3.312 0 1.366-.586 2.59-1.518 3.444 1.474.8 2.74 1.925 3.677 3.282 1.137 1.647 1.788 3.635 1.738 5.797h0H5.273c-.05-2.19.62-4.207 1.775-5.801C7.99 9.6 9.258 8.578 10.72 7.97c-.942-1.158-1.55-2.402-1.55-3.788 0-1.295.524-2.465 1.37-3.312.847-.847 2.018-1.37 3.312-1.37z"
          transform="translate(1 4)"
        />
        <path
          d="M6.771.284c1.109 0 2.11.467 2.82 1.208-.285 1.213-.49 1.927-.49 2.69 0 .757.208 1.459.567 2.064-.15 1.106.07 1.218.279 1.326.3.155.616.323 1.16.384-.4.14-.788.308-1.157.502-2.23 1.175-4.023 3.42-4.586 6.156h0-5.866c-.053-1.862.538-3.576 1.558-4.92.795-1.047 1.851-1.869 3.067-2.36-.762-.993-1.25-2.016-1.25-3.152 0-1.078.436-2.053 1.14-2.757C4.72.72 5.694.285 6.772.285z"
          transform="translate(1 4)"
        />
      </g>
      <path d="M0 0H24V24H0z" />
    </g>
  </svg>
);

CreatePartnership.defaultProps = {
  ariaLabel: '',
};

CreatePartnership.propTypes = {
  ariaLabel: PropTypes.string,
  color: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default CreatePartnership;
